﻿import { tns } from 'tiny-slider/src/tiny-slider.js';
if (document.getElementsByClassName("slider-headervisual-container").length) {
    tns({
        container: '.slider-headervisual-container',
        autoplay: true,
        autoplayTimeout: 8000,
        autoplayButtonOutput: false,
        speed: 1000,
        items: 1,
        slideBy: 1,
        controlsPosition: 'bottom',
        navPosition: 'bottom',
        prevButton: '.slider-headervisual .tns-button-prev',
        nextButton: '.slider-headervisual .tns-button-next',
        mouseDrag: true,
        onInit: function (tns) {
            let $navContainer = document.querySelector('.slider-headervisual .tns-pagination');
            let $originalNav = document.querySelector('.slider-headervisual .tns-nav');
            $navContainer.append($originalNav);

            tns.nextButton.setAttribute('tabindex', 0);
            tns.prevButton.setAttribute('tabindex', 0);
        }
    });
}